import React, { useState, useEffect } from 'react'
import {ArrowUpTrayIcon} from '@heroicons/react/24/solid'

const InputFile = () => {
    const handleState = (blob) => 
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onerror = reject;
          reader.onload = () => {
            resolve(reader.result);
          };
          reader.readAsDataURL(blob);
        });

    const [fileName, setFilename] = useState()
    const [file, setFile] = useState()    

    useEffect(() => {
        
        
      console.log('file: ', file)
    }, [file])
    
  return (
    <>
<div className="bg-primarioMira shadow sm:rounded-lg">
<div className="px-4 py-5 sm:p-6">
  <h3 className="text-base font-semibold leading-6 text-white">Enviar archivo</h3>
  <div className="mt-2 sm:flex sm:items-start sm:justify-between">
    <div className="max-w-xl text-sm text-gray-400 ">
      <p>
        En esta opción, seleccione el archivo que va a cargar al sistema.
      </p>
    </div>
    <div className="mt-5 sm:ml-6 sm:mt-0 sm:flex sm:flex-shrink-0 sm:items-center flex flex-row ">
      <label 
        htmlFor="file-upload"
        className='bg-azulBrillanteMira text-white /inline rounded-md p-2 justify-center flex flex-row hover:cursor-pointer'
      ><ArrowUpTrayIcon className='h-6 w-6 text-white mr-1'></ArrowUpTrayIcon>
        Seleccionar archivo</label>
      <input
        type="file"
        name=""
        id="file-upload"
        accept='.zip, .rar, .xml, .csv, .xls, .xlsx'
        className='text-white /inline bg-gray-500 rounded-md hidden'
        onChange={async (e) => {
            const base64 = await handleState(
                e.target.files[0]
                );
                setFilename(e.target.files[0]['name'])
                setFile(base64)
        }}
      ></input>
      {<p className='text-white p-1'>{fileName}</p>}
    </div>
  </div>
</div>
</div>
    </>
  )
}

export default InputFile


